import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  InputGroup,
  Row,
} from "reactstrap";

import * as Yup from "yup";
import ModalLoding from "../../Components/Common/ModalLoading";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import Modal from "../../Components/Common/Modal";
import states from "../../utils/states.json";

import UiContent from "../../Components/Common/UiContent";
import { MANDATORY_FIELD } from "../../Components/constants/messages";
import {
  CoverUploadImageField,
  InputMask,
  TextField,
} from "../../Components/Forms";
import LazyImage from "../../Components/LazyImage/LazyImage";
import Loading from "../../Components/Loading/Loading";
import PlaceMenu from "../../Components/Places/PlaceMenu";
import { getCitiesRequest } from "../../store/city/actions";
import { getFiltersWhereEatRequest } from "../../store/filters/whereEat/actions";

import {
  deleteRestaurantPhotoRequest,
  getRestaurantRequest,
  updateRestaurantPhotoRequest,
  updateRestaurantRequest,
} from "../../store/restaurants/actions";
import { isLatitude, isLongitude } from "../../utils/formats";
import { api } from "../../boot/api";
import showNofity from "../../helpers/toast";
import { Checkbox } from "../../Components/Forms/Checkbox";

const RestaurantFormEdit = () => {
  document.title = "Restaurante | Ecoguias - Admin Dashboard";
  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.Restaurant);
  const { data: dataCity } = useSelector((state) => state.City);
  const { loading: loadingFilter, data: dataFilter } = useSelector(
    (state) => state.FiltersWhereEat
  );

  const [legendImage, setLegendImage] = useState([]);

  const [modalIsOpenRemove, setModalIsOpenRemove] = useState(false);
  const [modalIsOpenSelect, setModalIsOpenSelect] = useState(false);
  const [photoId, setPhotoId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const { id } = useParams();
  const history = useHistory();

  useEffect(() => {
    dispatch(getRestaurantRequest(id));
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(getCitiesRequest());
    dispatch(getFiltersWhereEatRequest());
  }, [dispatch]);

  const restaurantExists = data?.result?.restaurant;
  const restaurantResponse = data?.result?.restaurant;

  const restaurant = useFormik({
    enableReinitialize: true,

    initialValues: {
      nome: restaurantExists ? restaurantResponse?.nome : "",
      telefones: restaurantExists ? restaurantResponse?.telefones : "",
      logradouro: restaurantExists ? restaurantResponse?.logradouro : "",
      numero: restaurantExists ? restaurantResponse?.numero : "",
      bairro: restaurantExists ? restaurantResponse?.bairro : "",
      cidade: restaurantExists ? restaurantResponse?.cidade?.objectId : "",
      estado: restaurantExists ? restaurantResponse?.estado : "",
      latitude: restaurantExists ? restaurantResponse?.gps?.latitude : "",
      longitude: restaurantExists ? restaurantResponse?.gps?.longitude : "",
      images: restaurantExists ? restaurantResponse?.images : [],
      url_video: restaurantExists ? restaurantResponse?.url_video : "",
      whatsapp: restaurantExists ? restaurantResponse?.whatsapp : "",
      instagram: restaurantExists ? restaurantResponse?.instagram : "",
      email: data?.result?.restaurant ? restaurantResponse?.email : "",
      media_preco: restaurantExists ? restaurantResponse?.media_preco : "",
      url_site: restaurantExists ? restaurantResponse?.url_site : "",
      descritivo: restaurantExists ? restaurantResponse?.descritivo : "",
      // tipo_culinaria: restaurantExists
      //   ? restaurantResponse?.tipo_culinaria
      //   : "",
      patrocinado:
        restaurantExists ? restaurantResponse?.patrocinado : false,
      filtro_onde_comer: restaurantExists
        ? restaurantResponse?.filtro_onde_comer?.objectId
        : "",
    },

    validationSchema: Yup.object({
      nome: Yup.string().required(MANDATORY_FIELD),
      telefones: Yup.string(),
      logradouro: Yup.string(),
      numero: Yup.string(),
      bairro: Yup.string(),
      cidade: Yup.string().required(MANDATORY_FIELD),
      estado: Yup.string(),
      latitude: Yup.string()
        .nullable()
        .test("is-latitude", "Insira uma latitude válida", (value) =>
          value ? isLatitude(value) : true
        ),
      longitude: Yup.string()
        .nullable()
        .test("is-longitude", "Insira uma longitude válida", (value) =>
          value ? isLongitude(value) : true
        ),
      // .required(MANDATORY_FIELD),
      images: Yup.array(Yup.string()),
      url_video: Yup.string(),
      whatsapp: Yup.string(),
      instagram: Yup.string(),
      email: Yup.string(),
      media_preco: Yup.string().notRequired(),
      url_site: Yup.string(),
      descritivo: Yup.string().required(MANDATORY_FIELD),
      patrocinado: Yup.boolean(),
      // tipo_culinaria: Yup.string().required(MANDATORY_FIELD),
      filtro_onde_comer: Yup.string().required(MANDATORY_FIELD),
    }),

    onSubmit: async (values) => {
      values.latitude = values.latitude ? Number(values.latitude) : 0.0;
      values.longitude = values.longitude ? Number(values.longitude) : 0.0;

      dispatch(
        updateRestaurantRequest({
          id: id,
          values,
          onSucess: () => restaurant.setFieldValue("images", []),
        })
      );
    },
  });

  function addLegendInState(index, txt) {
    const copyLegend = [...legendImage];
    copyLegend[index] = txt;

    setLegendImage(copyLegend);
  }

  async function updateLegend(imagemId, legenda) {
    try {
      await api.post("/photo-restaurant-update-legend", { imagemId, legenda });
      showNofity.success("Legenda salva com sucesso");
    } catch (error) {
      showNofity.error("Erro ao salvar legenda");
    }
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Editar alimentação" pageTitle="Alimentação" />
        </Container>

        <Col lg={12}>
          <Card>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>

            <CardBody>
              <div className="live-preview">
                <Row className="g-3">
                  <CoverUploadImageField
                    title="Adicionar imagens"
                    multiple
                    data={restaurant}
                    name="images"
                    isActiveRadioSelect={false}
                  />

                  <TextField label="Nome" name="nome" data={restaurant} />

                  {/* <TextField
                    label="Tipo de culinária"
                    name="tipo_culinaria"
                    data={restaurant}
                  /> */}

                  <TextField
                    type="select"
                    label="Filtro"
                    name="filtro_onde_comer"
                    data={restaurant}
                    size={6}
                  >
                    <option value="" selected disabled>
                      Selecione o filtro
                    </option>
                    {dataFilter?.result?.length > 0 &&
                      dataFilter?.result?.map((item, idx) => (
                        <option key={idx} value={item.objectId}>
                          {item.nome}
                        </option>
                      ))}
                  </TextField>

                  <InputMask
                    type="phone-br"
                    label="Telefone"
                    name="telefones"
                    data={restaurant}
                  />

                  <TextField
                    label="Logradouro"
                    name="logradouro"
                    data={restaurant}
                  />

                  <TextField
                    label="Número"
                    name="numero"
                    data={restaurant}
                    size={2}
                  />
                  <TextField
                    label="Bairro"
                    size={4}
                    name="bairro"
                    data={restaurant}
                  />

                  <TextField
                    label="Cidade"
                    name="cidade"
                    type="select"
                    data={restaurant}
                    size={4}
                  >
                    <option value="" selected disabled>
                      Selecione a cidade
                    </option>
                    {dataCity?.result?.length > 0 &&
                      dataCity?.result.map((item, index) => (
                        <option key={index} value={item.objectId}>
                          {item.nome}
                        </option>
                      ))}
                  </TextField>

                  <TextField
                    label="Estado"
                    name="estado"
                    type="select"
                    data={restaurant}
                    size={2}
                  >
                    <option value="" selected disabled>
                      Selecione o estado
                    </option>

                    {states.map(({ sigla, id_uf }) => (
                      <option key={id_uf} value={sigla}>
                        {sigla}
                      </option>
                    ))}
                  </TextField>

                  <TextField
                    label="Latitude"
                    name="latitude"
                    data={restaurant}
                    type="number"
                    size={2}
                    onKeyDown={(event) => {
                      ["e", "E", "+", ","].includes(event.key) &&
                        event.preventDefault();
                    }}
                  />
                  <TextField
                    label="Longitude"
                    name="longitude"
                    data={restaurant}
                    type="number"
                    size={2}
                    onKeyDown={(event) => {
                      ["e", "E", "+", ","].includes(event.key) &&
                        event.preventDefault();
                    }}
                  />

                  <TextField
                    label="Preço médio"
                    name="media_preco"
                    type="select"
                    data={restaurant}
                    size={2}
                  >
                    <option value="" selected disabled>
                      Selecione o preço
                    </option>
                    <option value="$">$</option>
                    <option value="$$">$$</option>
                    <option value="$$$">$$$</option>
                    <option value="$$$$">$$$$$</option>
                    <option value="$$$$$$">$$$$$$</option>
                  </TextField>

                  <TextField
                    label="Vídeo do local (URL)"
                    name="url_video"
                    data={restaurant}
                  />

                  <InputMask
                    type="phone-br"
                    label="WhatsApp"
                    name="whatsapp"
                    data={restaurant}
                  />

                  <TextField
                    label="Instagram"
                    name="instagram"
                    data={restaurant}
                  />

                  <TextField label="E-mail" name="email" data={restaurant} />

                  <TextField label="Site" name="url_site" data={restaurant} />

                  <TextField
                    size={12}
                    type="textarea"
                    label="Descrição"
                    name="descritivo"
                    data={restaurant}
                  />

                  <Checkbox
                    label="Estabelecimento patrocinado"
                    name="patrocinado"
                    data={restaurant}
                  />

                  {data?.result?.images?.length > 0 && (
                    <>
                      <h3>Imagens do local</h3>
                      <p>
                        Escolha uma opção abaixo para excluir uma imagem ou
                        selecionar a imagem principal do local
                      </p>
                    </>
                  )}

                  {id && (
                    <React.Fragment>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 10,
                        }}
                      >
                        {data?.result?.images?.map((item, idx) => {
                          return item.imagem?.name ? (
                            <div>
                              <Col key={idx} lg={3} style={styles.imageList}>
                                {item.imagem.url !==
                                data?.result?.restaurant?.imagem.url ? (
                                  <PlaceMenu
                                    remove={() => {
                                      setPhotoId(item.objectId);
                                      setModalIsOpenRemove(true);
                                    }}
                                    select={() => {
                                      setSelectedImage(item?.imagem);
                                      setModalIsOpenSelect(true);
                                    }}
                                  />
                                ) : null}
                                <LazyImage
                                  src={item?.imagem?.url}
                                  width="100%"
                                  height="100%"
                                  className="object-fit-cover rounded"
                                  style={
                                    item.imagem.url ===
                                    data?.result?.restaurant?.imagem.url
                                      ? styles.lazyImage
                                      : null
                                  }
                                />
                              </Col>
                              <div style={{ marginTop: 10 }}></div>
                              <InputGroup>
                                <Input
                                  value={item.legenda}
                                  title="Legenda"
                                  name="Legenda"
                                  placeholder="Legenda"
                                  size="sm"
                                  className="form-control"
                                  onChange={(event) =>
                                    addLegendInState(idx, event.target.value)
                                  }
                                />
                                <Button
                                  size="sm"
                                  className="primary"
                                  onClick={() =>
                                    updateLegend(
                                      item.objectId,
                                      legendImage[idx]
                                    )
                                  }
                                >
                                  <i className="ri-save-2-line fs-13"></i>
                                </Button>
                              </InputGroup>
                            </div>
                          ) : null;
                        })}
                      </div>
                    </React.Fragment>
                  )}

                  <Col lg={12}>
                    <div className="text-end">
                      <button
                        onClick={() => restaurant.handleSubmit()}
                        type="button"
                        className="btn btn-primary"
                      >
                        Salvar
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        </Col>
      </div>

      <Modal
        isOpen={modalIsOpenRemove}
        text="Tem certeza que deseja remover essa imagem?"
        onClick={() => {
          dispatch(
            deleteRestaurantPhotoRequest({
              restaurantId: id,
              photoId: photoId,
            })
          );

          setModalIsOpenRemove(false);
        }}
        onCancel={() => {
          setModalIsOpenRemove(false);
        }}
      />

      <Modal
        isOpen={modalIsOpenSelect}
        text="Tem certeza que deseja selecionar essa imagem como a principal deste restaurante?"
        onClick={() => {
          dispatch(
            updateRestaurantPhotoRequest({
              restaurantId: id,
              imagem: selectedImage,
            })
          );

          setModalIsOpenSelect(false);
        }}
        onCancel={() => {
          setModalIsOpenSelect(false);
        }}
      />
      <ModalLoding loading={loading} />
    </React.Fragment>
  );
};

const styles = {
  lazyImage: {
    borderColor: "#93bf85",
    borderWidth: 5,
    borderStyle: "solid",
    borderRadius: 10,
  },
  imageList: {
    display: "flex",
    position: "relative",
    height: 220,
    width: 260,
  },
};

export default RestaurantFormEdit;
